import { addDoc, collection, deleteDoc, doc, getDoc, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

const deletedAttendeesCollection = collection(db, "deleted_attendees");
const attendeesCollection = collection(db, "attendees");

const deletedAttendeeService = { 
  getAll: async () => {
    try {  
      const deletedAttendeesSnapshot = await getDocs(deletedAttendeesCollection);
      const deletedAttendeesList = deletedAttendeesSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return deletedAttendeesList;
    } catch (error) {
      console.error('Error fetching deleted Attendees:', error);
      throw error;
    }
   },

    restore: async (deletedAttendeeId) => {
        try {
        const deletedAttendeeRef = doc(db, "deleted_attendees", deletedAttendeeId);
        const deletedAttendeeSnap = await getDoc(deletedAttendeeRef);
        
        if (deletedAttendeeSnap.exists()) {
            // First add to attendees collection
            const restoredDoc = await addDoc(attendeesCollection, {
            ...deletedAttendeeSnap.data(),
            original_id: deletedAttendeeId,
            });
            // Then delete from deleted_attendees
            await deleteDoc(deletedAttendeeRef);
            return restoredDoc.id;
        }
        throw new Error('Deleted attendee not found');
        } catch (error) {
        console.error('Error restoring attendee:', error);
        throw error;
        }
    },

    delete: async (deletedAttendeeId) => {
        try {
        const deletedAttendeeRef = doc(db, "deleted_attendees", deletedAttendeeId);
        await deleteDoc(deletedAttendeeRef);
        return true;
        } catch (error) {
        console.error('Error deleting deleted attendee:', error);
        throw error;
        }
    },
};

export default deletedAttendeeService;